import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Table, TableModule } from "primeng/table";
import { GenericResponseDto } from "../../../core/models/generic-response.dto";
import { InvoiceEmail } from "../../../core/models/orders/invoicedEmail";
import { OrderBcEmailDto } from "../../../core/models/orders/orderBcEmailDto";
import { GetUserDto } from "../../../core/models/users/users/getUserDto";
import { ValidateLogin } from "../../../core/models/validate-login.dto";
import { OrderSummaryService } from "../../../core/services/order-summary.service";
import { ProfileFormService } from "../../../core/services/profile-form.service";
import { CommonModule } from "@angular/common";
import { UserManagementService } from "../../../core/services/user-management.service";
import { CheckboxModule } from "primeng/checkbox";
import { FormsModule } from "@angular/forms";
import { SelectModule } from "primeng/select";
import { ButtonModule } from "primeng/button";
import { JniToastrService } from "../../../core/services/jni-toastr.service";

@Component({
  selector: "jni-invoice-preview-invoice-emails",
  templateUrl: "./invoice-preview-invoice-emails.component.html",
  styleUrls: ["./invoice-preview-invoice-emails.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    CheckboxModule,
    FormsModule,
    SelectModule,
    ButtonModule,
  ],
})
export class InvoicePreviewInvoiceEmailsComponent implements OnInit {
  @Input() invoiceEmailListing: InvoiceEmail[] = [];
  @Output() invoiceEmailDeletedEvent = new EventEmitter<InvoiceEmail[]>();
  @Output() invoiceEmailAddEvent = new EventEmitter<boolean>();
  @Output() invoiceEmailCopyBcEmailEvent = new EventEmitter<string>();
  @Output() invoiceEmailCopyBacEmailEvent = new EventEmitter<string>();
  @Output() invoiceEmailAddBcBacEmailEvent = new EventEmitter<{
    email: string;
    name: string;
  }>();
  @Output() invoiceEmailEditEvent = new EventEmitter<InvoiceEmail>();
  @Output() invoiceEmailSaveEvent = new EventEmitter<InvoiceEmail>();

  @Input() salesOrderId = "";
  orderBcEmail: OrderBcEmailDto = { email: "", name: "" };
  orderBacEmail: OrderBcEmailDto = { email: "", name: "" };
  invoiceEmailSelected = [];
  copyBcCheckbox = false;
  copyBacCheckbox = false;
  showSmallLoader = false;
  userData!: GetUserDto;
  type = [
    {
      id: 1,
      name: "Business",
    },
    {
      id: 2,
      name: "Invoice",
    },
    {
      id: 3,
      name: "Payable",
    },
    {
      id: 4,
      name: "Delivery",
    },
    {
      id: 5,
      name: "Other",
    },
    {
      id: 6,
      name: "Buyer",
    },
  ];

  @ViewChild("dt") table!: Table;

  constructor(
    private _profileFormService: ProfileFormService,
    private _loginService: UserManagementService,
    private _orderSummaryService: OrderSummaryService,
    private _toastrService: JniToastrService
  ) {}
  ngOnInit(): void {
    this.getUserProfile();
    this.getOrderBacEmailBySalesOrderId();
    this.getOrderBcEmailBySalesOrderId();
  }

  // ngOnChanges(): void {
  //   this.getUserProfile();
  // }

  onDelete() {
    this.invoiceEmailDeletedEvent.emit(this.invoiceEmailSelected);
    this.invoiceEmailSelected = [];
  }

  onAdd() {
    this.invoiceEmailAddEvent.emit(true);
    this.invoiceEmailSelected = [];
  }

  onEditRow(invoiceEmails: InvoiceEmail) {
    this.invoiceEmailEditEvent.emit(invoiceEmails);
  }

  onSaveRow(invoiceEmails: InvoiceEmail) {
    this.invoiceEmailSaveEvent.emit(invoiceEmails);
  }

  copyBcBAcToGrid(type: string) {
    if (type === "bac") {
      if (this.orderBacEmail.email === "") {
        this._toastrService.error(
          "Error",
          "No display email found at BAC's User Profile"
        );
        setTimeout(() => {
          this.copyBacCheckbox = false;
        });
        return;
      }
    } else if (type === "bc") {
      if (this.orderBcEmail.email === "") {
        this._toastrService.error(
          "Error",
          "No display email found at BC's User Profile"
        );
        setTimeout(() => {
          this.copyBcCheckbox = false;
        });
        return;
      }
    }
    if (this.copyBacCheckbox) {
      const index = this.invoiceEmailListing.findIndex(
        x => x.email === this.orderBacEmail.email
      );
      if (index == -1) {
        this.invoiceEmailAddBcBacEmailEvent.emit({
          email: this.orderBacEmail.email,
          name: this.orderBacEmail.name,
        });
        this.onAdd();
      }
      this.invoiceEmailCopyBacEmailEvent.emit(this.orderBacEmail.email);
    } else {
      this.invoiceEmailCopyBacEmailEvent.emit("");
    }

    if (this.copyBcCheckbox) {
      const index = this.invoiceEmailListing.findIndex(
        x => x.email === this.orderBcEmail.email
      );
      if (index == -1) {
        this.invoiceEmailAddBcBacEmailEvent.emit({
          email: this.orderBcEmail.email,
          name: this.orderBcEmail.name,
        });
        this.onAdd();
      }
      this.invoiceEmailCopyBcEmailEvent.emit(this.orderBcEmail.email);
    } else {
      this.invoiceEmailCopyBcEmailEvent.emit("");
    }
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.getUserById(res?.data?.userId);
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: async res => {
        if (res?.data) {
          this.userData = res?.data;
          this.isCopyBcBacEnabled();
        }
      },
    });
  }

  isCopyBcBacEnabled() {
    const indexForBac = this.invoiceEmailListing.findIndex(
      x => x.email === this.orderBacEmail.email
    );
    if (indexForBac != -1) {
      this.copyBacCheckbox = true;
      this.invoiceEmailCopyBacEmailEvent.emit(this.orderBacEmail.email);
    }

    const indexForBc = this.invoiceEmailListing.findIndex(
      x => x.email === this.orderBcEmail.email
    );
    if (indexForBc != -1) {
      this.copyBcCheckbox = true;
      this.invoiceEmailCopyBcEmailEvent.emit(this.orderBcEmail.email);
    }
  }

  getOrderBacEmailBySalesOrderId() {
    if (this.salesOrderId) {
      this._orderSummaryService
        .getOrderBacEmailBySalesOrderId(this.salesOrderId)
        .pipe()
        .subscribe((res: GenericResponseDto<OrderBcEmailDto>) => {
          if (res?.status === "Success" && res?.data) {
            this.orderBacEmail = res.data || { email: "", name: "" };
          }
        });
    }
  }

  getOrderBcEmailBySalesOrderId() {
    if (this.salesOrderId) {
      this._orderSummaryService
        .getOrderBcEmailBySalesOrderId(this.salesOrderId)
        .pipe()
        .subscribe((res: GenericResponseDto<OrderBcEmailDto>) => {
          if (res?.status === "Success" && res?.data) {
            this.orderBcEmail = res.data || { email: "", name: "" };
          }
        });
    }
  }
}
